import _ from 'lodash';
import React from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import {reduxForm, formValueSelector} from 'redux-form';

import Warning from 'components/Warning';
import ErrorBlock from 'components/ErrorBlock';

import {BaseFields, ItemFields} from './components';

import {formatDate, formatDateForApi, DATE_FORMAT} from 'utils/datetime';

import {
  fetchXeroTaxRates,
  createDraftInvoice,
  fetchCanCreateFinanceItemForPastMonths
} from 'ducks/tenancy';
import {MODALS} from 'ducks/bookings';

import {selectModal} from 'ducks/modals';

import './styles.css';

const formSubmit = (values, dispatch, props) => {
  const {locationRef, scheduleId} = props;

  const postData = {
    location: locationRef,
    xeroTaxRate: _.get(values, 'xeroTaxRate.value'),
    xeroAccount: _.get(values, 'xeroAccount.id'),
    dateIssued: formatDateForApi(_.get(values, 'dateIssued')),
    dueDate: formatDateForApi(_.get(values, 'dueDate')),
    rentStart: formatDateForApi(_.get(values, 'rentStart')),
    rentEnd: formatDateForApi(_.get(values, 'rentEnd')),
    rentReference: _.get(values, 'rentReference'),
    itemDescription: _.get(values, 'itemDescription', ''),
    quantity: _.get(values, 'quantity'),
    unitPrice: _.get(values, 'unitPrice'),
    schedule: scheduleId
  };

  dispatch(createDraftInvoice(postData, props.submitExtraActions()));
};

class DraftInvoiceCreateForm extends React.Component<any> {
  componentDidMount() {
    const fetchCanCreateFinanceItemForPastMonthsExtraAction = this.props.storeDataExtraActions(
      data => ({
        canCreateDraftInvoiceForPastMonths: _.get(
          data,
          'canCreateFinanceItemsForPastMonths'
        )
      })
    );

    this.props.fetchCanCreateFinanceItemForPastMonths(
      {locationRef: this.props.locationRef},
      fetchCanCreateFinanceItemForPastMonthsExtraAction
    );
  }
  componentDidUpdate(prevProps) {
    const {xeroAccounts} = this.props;
    const accountsFetched = xeroAccounts !== _.get(prevProps, 'xeroAccounts');

    if (accountsFetched && !_.isEmpty(xeroAccounts)) {
      const accountClass = _.get(xeroAccounts, '[0].accountClass');

      this.props.fetchXeroTaxRatesForAccount({accountClass});
    }
  }

  render() {
    const {
      handleSubmit,
      error,
      selectedScheduleType,
      xeroAccounts,
      xeroTaxRates,
      fetchXeroTaxRatesForAccount,
      lineAmount,
      onUnitPriceChange,
      onQuantityChange,
      selectedDueDate,
      canCreateDraftInvoiceForPastMonths
    } = this.props;

    const xeroAccountOptions = xeroAccounts.map(xeroAccount => ({
      value: `${xeroAccount.id} - ${xeroAccount.label}`,
      label: xeroAccount.label,
      accountClass: xeroAccount.accountClass,
      id: xeroAccount.id
    }));

    const xeroTaxRatesOptions = xeroTaxRates.map(xeroTaxRate => ({
      value: xeroTaxRate.id,
      label: xeroTaxRate.name,
      object: xeroTaxRate
    }));

    const draftInvoiceApprovalThreshold = moment().add(42, 'days');
    const dueDateIsBeforeThreshold = moment(
      selectedDueDate,
      DATE_FORMAT
    ).isBefore(draftInvoiceApprovalThreshold);

    return (
      <div>
        {error && <ErrorBlock>{error}</ErrorBlock>}
        {dueDateIsBeforeThreshold && (
          <Warning>
            You have selected a due date that requires invoice creation in Xero.
            Invoice should be created instead
          </Warning>
        )}
        <form onSubmit={handleSubmit} className="DraftInvoiceCreateForm">
          <BaseFields
            xeroAccountOptions={xeroAccountOptions}
            scheduleType={this.props.scheduleType || selectedScheduleType}
            fetchXeroTaxRatesForAccount={fetchXeroTaxRatesForAccount}
            canCreateDraftInvoiceForPastMonths={
              canCreateDraftInvoiceForPastMonths
            }
          />
          <ItemFields
            xeroTaxRatesOptions={xeroTaxRatesOptions}
            lineAmount={lineAmount}
            onUnitPriceChange={onUnitPriceChange}
            onQuantityChange={onQuantityChange}
          />
        </form>
      </div>
    );
  }
}

const formSelector = formValueSelector('createDraftInvoice');

const mapStateToProps = state => {
  const {
    data: {xeroAccounts, canCreateDraftInvoiceForPastMonths}
  } = selectModal(state, MODALS.CREATE_DRAFT_INVOICE);

  const today = formatDate(moment());

  return {
    initialValues: {
      quantity: 1,
      unitPrice: 0,
      dateIssued: today,
      dueDate: today,
      xeroAccount: _.first(xeroAccounts)
    },
    selectedScheduleType: _.get(formSelector(state, 'scheduleType'), 'value'),
    canCreateDraftInvoiceForPastMonths,
    selectedDueDate: formSelector(state, 'dueDate')
  };
};

const mapDispatchToProps = {
  fetchXeroTaxRates,
  createDraftInvoice,
  fetchCanCreateFinanceItemForPastMonths
};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'createDraftInvoice',
    onSubmit: formSubmit,
    enableReinitialize: true
  })(DraftInvoiceCreateForm)
);
